/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartExecutionResponse
 */
export interface StartExecutionResponse {
    /**
     * Unique execution ID
     * @type {string}
     * @memberof StartExecutionResponse
     */
    executionId: string;
    /**
     * ARN of the started state machine execution
     * @type {string}
     * @memberof StartExecutionResponse
     */
    stateMachineArn: string;
}

/**
 * Check if a given object implements the StartExecutionResponse interface.
 */
export function instanceOfStartExecutionResponse(value: object): value is StartExecutionResponse {
    if (!('executionId' in value) || value['executionId'] === undefined) return false;
    if (!('stateMachineArn' in value) || value['stateMachineArn'] === undefined) return false;
    return true;
}

export function StartExecutionResponseFromJSON(json: any): StartExecutionResponse {
    return StartExecutionResponseFromJSONTyped(json, false);
}

export function StartExecutionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartExecutionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'executionId': json['executionId'],
        'stateMachineArn': json['stateMachineArn'],
    };
}

export function StartExecutionResponseToJSON(json: any): StartExecutionResponse {
    return StartExecutionResponseToJSONTyped(json, false);
}

export function StartExecutionResponseToJSONTyped(value?: StartExecutionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'executionId': value['executionId'],
        'stateMachineArn': value['stateMachineArn'],
    };
}

